import { ProcedureUnitTypeRulesConfig } from '@core/procedure-helpers/models/unit-type-rules-config';
import { rulesForFixedRestorativeGlidewellIo } from './unit-type-rules/fixed-restorative-glidewell-io';
import { rulesForImplantPlanning } from '@core/procedure-helpers/teeth-diagram/unit-type-rules/implant-planning';
import { rulesForImplantPlanningGuideTooth } from '@core/procedure-helpers/teeth-diagram/unit-type-rules/implant-planning-guide-tooth';
import { rulesForDentureRemovableImplantBased } from '@core/procedure-helpers/teeth-diagram/unit-type-rules/denture-removable-implant-based';
import { rulesForRemovablePartialDentureFramework } from './unit-type-rules/denture-removable-partial-framework';
import { rulesForRemovableImmediateDentureFramework } from './unit-type-rules/denture-removable-immediate';
import { rulesForFixedRestorative } from './unit-type-rules/fixed-restorative';
import { rulesForRemovablePartialDentureAcrylic } from './unit-type-rules/denture-removable-acrylic';
import { rulesForImplantPlanningDefaultSendToEmpty } from './unit-type-rules/implant-planning-default-sendto-empty';

export const procedureUnitTypeRules: ProcedureUnitTypeRulesConfig = {
	ProcedureRules: [
		rulesForFixedRestorativeGlidewellIo,
		rulesForFixedRestorative,
		rulesForImplantPlanningDefaultSendToEmpty,
		rulesForImplantPlanningGuideTooth,
		rulesForImplantPlanning,
		rulesForDentureRemovableImplantBased,
		rulesForRemovablePartialDentureFramework,
		rulesForRemovableImmediateDentureFramework,
		rulesForRemovablePartialDentureAcrylic
	]
};
